export default __webpack_public_path__ + "static/media/n.b0a66ae1.jpeg";